export interface SipTileData {
  route: string;
  title: string;
  description: string;
  imgSource: string | null;
}

export class SipTileStorage {
  private tiles: Record<string, SipTileData> = {};

  public getTile(route: string): SipTileData | undefined {
    return this.tiles[route];
  }

  public setTile(route: string, data: SipTileData): void {
    this.tiles = { ...this.tiles, [route]: data };
  }

  public removeTile(route: string): void {
    const { [route]: _, ...rest } = this.tiles;
    this.tiles = rest;
  }

  public getAllTiles(): SipTileData[] {
    return Object.values(this.tiles);
  }
}
